<template>
  <div>video select test1;</div>
</template>
<script>
export default {
  name: 'PublicTmpVideoSelect',
  props: {},
  data () {
    return {}
  },
  watch: {},
  created () {},
  methods: {}
}
</script>

<style scoped lang="scss"></style>
